import { define, select, ui, when } from '@owenscorning/pcb.alpha';


export default define`PimConnection`('0.0.1')({
  view: props => <></>,
  edit: ({ label, pimSource }) => (
    <UI.Form label={label}>
      {{
        linked_product: ui`Build/LinkPIM`({
          label: false,
          language: select`../language`,
          onChangeProduct: (product, path) => {
            Board.Change(product?.name || '', _.concat(_.initial(path), 'name'));
          },
          pimSource,
          product: when`~linked_object`.is.present.then(select`~linked_object`),
        }),
        linked_source: ui`Hidden`({
          noPadding: true,
          value: when`../linked_product`.is.present.then(pimSource).otherwise(undefined),
        }),
        linked_external_id: ui`Hidden`({
          noPadding: true,
          value: when`../linked_product`.is.present.then(select`../linked_product/id`).otherwise(undefined),
        }),
      }}
    </UI.Form>
  ),
});
